import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const ModalPopup = ({
  isOpen,
  title,
  message,
  onClose,
  onCancel,
  onConfirm,
  onDiscard,
  showSpinner,
  confirmLabel,
  cancelLabel,
  discardLabel,
  children,
  imageSrc, // new prop for optional image
  showFooter = true
}) => {
  const [sidebarWidth, setSidebarWidth] = useState(0);

  useEffect(() => {
    if (!isOpen) return;

    const measure = () => {
      const el = document.querySelector('.sidebar');
      const w = el && el.getBoundingClientRect ? el.getBoundingClientRect().width : 0;
      setSidebarWidth(Number.isFinite(w) ? w : 0);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isOpen]);

  if (!isOpen) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: sidebarWidth ? `${sidebarWidth}px` : 0,
    right: 0,
    bottom: 0,
    width: sidebarWidth ? `calc(100% - ${sidebarWidth}px)` : '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  };

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', textAlign: 'left' }}>
          <h2 style={{ color: '#fff', fontSize: '1.8rem', margin: 0, textAlign: 'left', flex: '1 1 auto', minWidth: 0 }}>{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            title="Close"
            style={{
              background: 'transparent',
              border: '1px solid #444',
              color: '#9aa0a6',
              borderRadius: '8px',
              padding: '8px 10px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <FaTimes />
          </button>
        </div>
        {imageSrc && (
          <img src={imageSrc} alt="Popup Visual" style={{ maxWidth: '100%', height: 'auto', margin: '10px 0' }} />
        )}
        {showSpinner && <div className="spinner" style={spinnerStyle} />}
        {children}
        <p style={{ color: '#ccc' }}>{message}</p>
        {showFooter && (
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
            {onCancel && (
              <button className="save-run-btn" onClick={onCancel}>{cancelLabel || 'Cancel'}</button>
            )}
            {onDiscard && (
              <button className="save-run-btn" onClick={onDiscard}>{discardLabel || 'Discard Data'}</button>
            )}
            {onConfirm && (
              <button className="save-run-btn" onClick={onConfirm}>{confirmLabel || 'OK'}</button>
            )}
            {!onConfirm && !onCancel && !onDiscard && (
              <button className="save-run-btn" onClick={onClose}>OK</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const modalStyle = {
  backgroundColor: '#0f0f0f',
  color: '#fff',
  padding: '20px',
  borderRadius: '10px',
  border: '1px solid #2a2a2a',
  width: '90vw',
  maxWidth: '720px',
  maxHeight: '90vh',
  overflowY: 'auto',
  height: 'auto',
  textAlign: 'center',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
};
const spinnerStyle = {
  margin: '10px auto', width: '40px', height: '40px', border: '4px solid #ccc', borderTop: '4px solid #333',
  borderRadius: '50%', animation: 'spin 1s linear infinite'
};

export default ModalPopup;